<template>
  <div>
    <card-wrapper>
      <matrix-upload-form :action-text="$t('page.integration.form.actionText')" :action="integrate" />
    </card-wrapper>

    <card-wrapper>
      <control-tabs />
    </card-wrapper>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import MatrixUploadForm from '@/components/matrix-upload-form.vue';
import ControlTabs from '@/components/control-report/control-tabs.vue';
import { integrate, reset } from '@/modules/matrix';
import CardWrapper from '@/components/interface/card-wrapper.vue';

export default Vue.extend({
  name: 'Integration',
  components: {
    MatrixUploadForm,
    ControlTabs,
    CardWrapper
  },
  methods: {
    integrate
  },
  destroyed: reset
});
</script>
